"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coalesce = void 0;
/**
 * Iterates through and returns the first defined argument.
 * @returns  the first non `null` and non `undefined` argument, or `undefined` if no such argument exists.
 */
function coalesce(...args) {
    for (const value of args) {
        if (value !== null && value !== undefined) {
            return value;
        }
    }
    return undefined;
}
exports.coalesce = coalesce;
//# sourceMappingURL=coalesce.js.map